import './api/axiosSetup3.ts'; // до всего остального
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { CustomerProvider } from './contexts/CustomerContext.tsx'
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      {/* <CustomerProvider> */}
        <BrowserRouter>
          <CssBaseline />
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider >
        </BrowserRouter>
      {/* </CustomerProvider> */}
  </StrictMode>,
)
